import { render, staticRenderFns } from "./cardDataStat.vue?vue&type=template&id=82339ac2&scoped=true&"
import script from "./cardDataStat.vue?vue&type=script&lang=js&"
export * from "./cardDataStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82339ac2",
  null
  
)

export default component.exports